import React from 'react';
import styled from "styled-components";
import {dateAgo} from "../../utils";
import {
    ActionsStyled,
    BodyStyled,
    CameraWrapperStyled,
    GoToAlertStyled,
    LabelStyled, StatusListStyled, StatusStyled,
    SummaryStyled
} from "./CommonStyles";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import AlertLabelShow from "./AlertLabelShow";
import ALERT_MAP from "../../maps/alertMap";

const WrapperStyled = styled.div`

`;

const AlertManager = ({data, goToAlert, handleStatusChange}) => {
    const [expanded, setExpanded] = React.useState(false);
    const handleAccordinoChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <WrapperStyled>
            {data.alerts.map((alert, idx) => {
                const type = ALERT_MAP.eventTypes[alert.eventSubType]?.title;

                const severity = alert.severity || 'CRITICAL';
                let alertStatus = alert.status;
                if (alert.status === "ACTIVE") {
                    alertStatus = "NOT HANDLED";
                }

                return (
                    <Accordion
                        TransitionProps={{unmountOnExit: true}}
                        key={alert._id + idx}
                        expanded={expanded === 'panel' + idx}
                        onChange={handleAccordinoChange('panel' + idx)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >
                            <SummaryStyled style={{gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr"}}>
                                <div>
                                    {dateAgo(alert.createdAt)}
                                </div>
                                <div>
                                            <span className={`${alert.status} status-class-pouu`}>
                                                {alertStatus}
                                            </span>
                                </div>
                                <div>
                                            <span className={severity}>
                                                {severity}
                                            </span>
                                </div>
                                <div>
                                    <AlertLabelShow
                                    label="Field"
                                    value={alert?.field?.name}
                                    />
                                </div>
                                <div>
                                    <AlertLabelShow
                                        label="Shelf"
                                        value={alert.data.boardId}
                                    />
                                </div>
                                <div>
                                    {type}
                                </div>
                                <div>
                                    {alert?.shopper?.name}
                                </div>
                            </SummaryStyled>
                        </AccordionSummary>
                        <AccordionDetails>
                            <BodyStyled>
                                <CameraWrapperStyled>

                                </CameraWrapperStyled>
                                <ActionsStyled>
                                    {alert.solution && (
                                        <div>
                                            <h4>Solution</h4>
                                            <div>
                                                <LabelStyled>Name:</LabelStyled>
                                                {alert.solution.name}
                                            </div>
                                        </div>
                                    )}

                                    <StatusStyled>
                                        <h4>Change Status</h4>
                                        <StatusListStyled>
                                            <Select
                                                labelId="select-label"
                                                value={alert.status}
                                                label="Age"
                                                onChange={(e) => handleStatusChange(e, alert)}
                                            >
                                                {Object.values(ALERT_MAP.statuses).map((act, iddx) => {
                                                    return (
                                                        <MenuItem key={act + iddx}
                                                                  value={act}>{act}</MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </StatusListStyled>
                                    </StatusStyled>
                                </ActionsStyled>
                            </BodyStyled>
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </WrapperStyled>
    );
};

export default AlertManager;